import { configureStore } from "@reduxjs/toolkit";
import { assetsReducer } from "./reducers/assets";
import { templateReducer } from "./reducers/template";
import { telecallerReducer } from "./reducers/telecaller";

export default configureStore({
  reducer: {
    assets: assetsReducer,
    templates: templateReducer,
    telecaller: telecallerReducer,
  },
});
